import {useLocale} from "@components/Contexts/LocaleContext"
import Typography, {
	Size,
	TypographyProps,
} from "@components/WebsiteRevamp/Typography/Typography"
import {translate} from "@helpers/translate"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CardsCategoryButton.module.scss"

type Props = {
	link: string
	data: CategoryModuleType
	modifier: string
	typograpyProps?: TypographyProps
}

const CardsCategoryButton = (props: Props) => {
	const {locale} = useLocale()

	return (
		<object className={styles.additionalTextLink}>
			<Typography
				as={"span"}
				content={translate(props.data.title, locale)}
				fontWeight={300}
				size={Size.XS}
				noPadding
				{...props.typograpyProps}
			/>
		</object>
	)
}

export default CardsCategoryButton
